// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/legacy_portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalAccountServiceIssueOidcLoginCodeRequest, LegacyPortalAccountServiceIssueOidcLoginCodeResponse, LegacyPortalAccountServiceLinkWithFanyIdRequest, LegacyPortalAccountServiceLinkWithFanyIdResponse, LegacyPortalAccountServiceSignInWithFanyIdRequest, LegacyPortalAccountServiceSignInWithFanyIdResponse } from "./legacy_portal_service_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.account.v1.LegacyPortalAccountService
 */
export const LegacyPortalAccountService = {
    typeName: "spwn.account.v1.LegacyPortalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.SignInWithFanyId
         */
        signInWithFanyId: {
            name: "SignInWithFanyId",
            I: LegacyPortalAccountServiceSignInWithFanyIdRequest,
            O: LegacyPortalAccountServiceSignInWithFanyIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.LinkWithFanyId
         */
        linkWithFanyId: {
            name: "LinkWithFanyId",
            I: LegacyPortalAccountServiceLinkWithFanyIdRequest,
            O: LegacyPortalAccountServiceLinkWithFanyIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.IssueOidcLoginCode
         */
        issueOidcLoginCode: {
            name: "IssueOidcLoginCode",
            I: LegacyPortalAccountServiceIssueOidcLoginCodeRequest,
            O: LegacyPortalAccountServiceIssueOidcLoginCodeResponse,
            kind: MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map